/* eslint-disable no-param-reassign */
// lp modal plugin
import * as focusTrap from 'focus-trap';
import { tabbable } from 'tabbable';

(function ($) {

	// Get the modal's vertical and horizontal + border + padding.
	function getModalOuterSize (modal) {

		const modalOuterWidth = Math.floor(parseInt(modal.css('padding-left'), 10)
				+ parseInt(modal.css('padding-right'), 10)
				+ parseInt(modal.css('border-left-width'), 10)
				+ parseInt(modal.css('border-right-width'), 10));
		const modalOuterHeight = Math.floor(parseInt(modal.css('padding-top'), 10)
				+ parseInt(modal.css('padding-bottom'), 10)
				+ parseInt(modal.css('border-top-width'), 10)
				+ parseInt(modal.css('border-bottom-width'), 10));

		return {
			modalOuterWidth,
			modalOuterHeight
		};

	}

	$.fn.lpModal = function (options) {

		const defaultCloseBtnSelector = '#lpModalClose';
		const lpModalId = 'lpModal';
		const defaultInitialFocusSelector = `#${lpModalId}`;
		let iframeModal;

		// default options
		const defaults = {
			onInit: false, // should modal open when code is initialized?
			fullScreen: false, // should we fill the whole screen?
			fullScreenOffset: {
				// if fullScreen, the x/y offset in px between the edge of the viewport and the modal
				// if fullScreen, this is the x and y offset in px between the edge of the viewport and the modal
				x: 0,
				y: 0
			},
			width: 560, // width of modal popup
			height: 470, // height for modal popup
			content: $('#content'), // html element that contains content on page
			appendContentToForm: true, // override to append content to body (WebForms, MVC hybrid patch)
			bgColor: '#fff', // background color of modal
			src: '', // url source of iframe to be embedded
			backdrop: true, // use dark overlay (backdrop)
			backdropClose: true, // should clicking on backdrop close modal?
			closeOnEscape: true, // should pressing ESC key close modal?
			closeBtn: defaultCloseBtnSelector, // close button selector
			showCloseBtn: true, // include close button
			lpModalClass: '', // class added to lpModal
			initialFocus: defaultInitialFocusSelector, // CSS selector, DOM node or function that returns eiher of the 2
			triggerId: '', // id of the element that triggered the modal (will be used as aria-labelledby)
			setReturnFocus: false, // CSS selector, DOM node or function that returns the element to focus on close
			openEvt () {}, // function to be run when modal opens
			afterOpenEvt () {}, // function to be run after modal opens (after animation is complete)
			preCloseEvt () {

				return 1;

			}, // function to be run before close, returns boolean
			closeEvt () {} // function to be ran after close has been run
		};

		// combine defaults and passed in options
		const o = $.extend(defaults, options);

		let modalFocusTrap;
		let iframeOnload;
		const isInitialFocusOnFirstContent = (initialFocus) => {

			if (typeof initialFocus === 'string') {

				return ![ defaultInitialFocusSelector, defaultCloseBtnSelector ].includes(initialFocus);

			}

			if (initialFocus && initialFocus.nodeType === Node.ELEMENT_NODE) {

				return initialFocus !== document.querySelector(defaultInitialFocusSelector)
					&& initialFocus !== document.querySelector(defaultCloseBtnSelector);

			}

			if (typeof initialFocus === 'function') {

				const initialFocusReturn = o.initialFocus();
				return isInitialFocusOnFirstContent(initialFocusReturn);

			}

			// boolean
			return initialFocus;

		};
		const iframeModalNextFocusHtml = '<div id="iframeModalNextFocus" tabindex="0" aria-hidden="true"></div>';
		const initModalFocusTrap = (modalContainer) => {

			let shiftTabKeyListener = () => {};
			let focusTrapInstance;
			const iframe = (() => {

				let sameDomain;
				const isSameDomain = () => {

					if (typeof sameDomain === 'boolean') {

						return sameDomain;

					}
					// this is executed only once on the first call
					const a = document.createElement('a');
					a.href = iframeModal.src;
					sameDomain = !a.host || a.host.startsWith('/') || a.host === window.location.host;
					return sameDomain;

				};

				return { isSameDomain };

			})();
			const activate = () => {

				const isStaticIframe = !!o.src;
				// modal content provided by an iframe must be immediate child of lpModalContent
				// so we don't select inner content (e.g. full screen PDP videos)
				const dynamicIframe = !isStaticIframe ? modalContainer.querySelector('#lpModalContent > iframe') : null;

				// for modal with iframe
				if (isStaticIframe || dynamicIframe) {

					// For dynamic iframe (e.g. YouTube), create the dummy iframeModalNextFocus tabbable at the end
					if (dynamicIframe) {

						const targetElement = document.getElementById('lpModalContent');
						const fragment = document.createRange().createContextualFragment(iframeModalNextFocusHtml);
						targetElement.appendChild(fragment);

					}

					const isTabPressed = (e) => e.key === 'Tab' || e.keyCode === 9;
					let isShifTabPressed = false;

					shiftTabKeyListener = (e) => {

						isShifTabPressed = e.shiftKey && isTabPressed(e);

					};

					const initIframeModalEvents = () => {

						// modal content provided by an iframe must be immediate child of lpModalContent
						// so we don't select inner content (e.g. full screen PDP videos)
						iframeModal = modalContainer.querySelector('#lpModalContent > iframe');

						let iframeTabbables = [];
						let bypassIframeFocus = false;

						// To have predictable focus trap behavior in modal with iframes,
						// the iframe must not be the last tabbable element in the trap.
						// That's why a dummy iframeModalNextFocus tabbable element is added.
						const iframeModalNextFocus = document.getElementById('iframeModalNextFocus');
						const iframeModalNextFocusHandler = () => {

							setTimeout(() => {
	
								const tabbables = tabbable(modalContainer);
	
								if (isShifTabPressed) {
	
									const latestIframeTabbables = iframe.isSameDomain()
										? tabbable(iframeModal.contentWindow.document.body)
										: [];
	
									if (latestIframeTabbables.length > 0) {
	
										latestIframeTabbables[latestIframeTabbables.length - 1].focus();
										bypassIframeFocus = true;
	
									} else if (iframe.isSameDomain()) {
	
										tabbables[0].focus();
										bypassIframeFocus = false;
	
									}
	
								} else {
	
									tabbables[0].focus();
									bypassIframeFocus = false;
	
								}
	
							}, 10);
	
						};

						const initIframeTabbables = (iframeDocument) => {

							// init once only
							if (iframe.isSameDomain() && iframeTabbables.length === 0) {

								const iframeDoc = iframeDocument || iframeModal.contentWindow.document;
								iframeTabbables = tabbable(iframeDoc.body);
								if (iframeTabbables.length > 0) {

									const tabbables = tabbable(modalContainer);

									// IE/FF need this to skip iframe focus and focus on the first tabbable (X button)
									iframeTabbables[0].addEventListener('keydown', (e) => {

										if (e.shiftKey && isTabPressed(e)) {

											setTimeout(() => {

												if (tabbables.length > 1 && document.activeElement !== tabbables[0]) {

													tabbables[0].focus();
													bypassIframeFocus = false;

												}

											}, 10);

										}

									});

									iframeDoc.addEventListener('keydown', shiftTabKeyListener);

								}

							}

						};

						iframeOnload = () => {

							initIframeTabbables();

							if (iframeTabbables.length > 0) {

								iframeModal.removeAttribute('tabindex');

								const setIframeFocusable = () => {
								
									const targetElement = document.getElementById('lpModalContent');
									const fragment = document.createRange().createContextualFragment(iframeModalNextFocusHtml);
									targetElement.appendChild(fragment);
									
									if (focusTrapInstance) {

										focusTrapInstance.pause();
									}
									iframeModal = modalContainer.querySelector('#lpModalContent > iframe');
									iframeModal.removeAttribute('tabindex');

									if (focusTrapInstance) {
										
										focusTrapInstance.unpause();

									}
									const iframeModalNextFocus = document.querySelector('#lpModalContent #iframeModalNextFocus');
									iframeModalNextFocus.addEventListener('focus', iframeModalNextFocusHandler);
								};

								if (!iframeModal.contentWindow) {
													
									setIframeFocusable()

								}
								const tabbables = tabbable(modalContainer);
								if (tabbables.length > 1) {

									// IE/FF need this to skip iframe focus and focus on the first tabbable inside iframe
									tabbables[0].addEventListener('keydown', (e) => {

										// get new iframeTabbables as the iframe may have dynamic elements
										if (!iframeModal.contentWindow) {
											
											setIframeFocusable();

										}
										const iframeDoc = iframeModal.contentWindow.document;
										iframeTabbables = tabbable(iframeDoc.body);

										if (iframeTabbables.length === 0) {

											return;

										}

										if (!e.shiftKey && isTabPressed(e)) {

											setTimeout(() => {

												iframeTabbables[0].focus();
												bypassIframeFocus = true;

											}, 10);

										}

									});

								}

							} else if (iframe.isSameDomain()) {

								iframeModal.setAttribute('tabindex', -1);

							}

						};

						document.addEventListener('keydown', shiftTabKeyListener);

						// Only IE receives focus event on iframe
						iframeModal.addEventListener('focus', () => {

							if (bypassIframeFocus) {

								return;

							}

							initIframeTabbables();

							setTimeout(() => {

								if (isShifTabPressed) {

									const tabbables = tabbable(modalContainer);
									tabbables[0].focus();
									bypassIframeFocus = false;

								} else if (iframeTabbables.length > 0) {

									iframeTabbables[0].focus();
									bypassIframeFocus = true;

								} else if (iframe.isSameDomain()) {

									iframeModalNextFocus.focus();

								}

							}, 10);

						});

						// When this dummy iframeModalNextFocus element gets focused,
						// we will steal the focus and switch it to the next or previous tabbable element
						
						iframeModalNextFocus.addEventListener('focus', iframeModalNextFocusHandler);

					};

					initIframeModalEvents();

				}

				const setReturnFocus = (() => {

					if (o.setReturnFocus && (
						typeof o.setReturnFocus === 'function' ||
						typeof o.setReturnFocus === 'string' ||
						o.setReturnFocus instanceof HTMLElement
					)) {

						return o.setReturnFocus;

					}

					// default to the element that triggered the modal
					return o.triggerId ? `#${o.triggerId}` : false;

				})();

				// initialize Focus Trap inside the modal
				focusTrapInstance = focusTrap.createFocusTrap(modalContainer, {
					clickOutsideDeactivates: true,
					preventScroll: true,
					initialFocus: o.initialFocus,
					fallbackFocus: defaultInitialFocusSelector,
					setReturnFocus
				});

				focusTrapInstance.activate();

			};

			const deactivate = () => {

				if (focusTrapInstance) {

					focusTrapInstance.deactivate();

					document.removeEventListener('keydown', shiftTabKeyListener);
					if (iframeModal && iframe.isSameDomain() && iframeModal.contentWindow) {

						iframeModal.contentWindow.document.removeEventListener('keydown', shiftTabKeyListener);

					}

				}

			};

			return {
				activate,
				deactivate
			};

		};

		if (!o.closeBtn) {

			o.closeBtn = defaultCloseBtnSelector;

		}

		this.each(function () {

			function initiateModal () {

				const isCloseBtnId = o.closeBtn[0] === '#';
				const closeBtnId = isCloseBtnId ? ` id="${o.closeBtn.replace('#', '')}"` : '';
				const closeBtnClass = !isCloseBtnId ? ` ${o.closeBtn.replace('.', '')}` : '';
				const ariaLabelledBy = o.triggerId ? ` aria-labelledby="${o.triggerId}"` : '';
				const modalTemplate = `<div id="lpModalBackdrop">
						<div id="${lpModalId}" class="lpModal--alt1" tabindex="-1" role="dialog"${ariaLabelledBy}>
							<button${closeBtnId}
								class="lpModalClose${closeBtnClass}${o.showCloseBtn ? '' : ' hidden'}"
								aria-label="Close popup">Close<span class="lpIcon-close02" aria-hidden="true"></span></button>
							<div id="lpModalContent"></div>
						</div>
					</div>`;
				// if we're using content on the page and there is a form tag
				// (check only the main one which is usually under body tag) on the page
				const isWebForm = 'webform' in document.querySelector('html').dataset;

				if (isWebForm && o.src.length === 0 && $('body > form').length > 0 && o.appendContentToForm) {

					// append template to body
					$('body > form').append(modalTemplate);

				} else {

					// append template to body
					$('body').append(modalTemplate);

				}

				// cache selectors used
				const modal = $('#lpModal');
				const modalContent = $('#lpModalContent');
				const $closeBtn = $(o.closeBtn);
				const $backdrop = $('#lpModalBackdrop');

				// --- these are basically the modal's margin + border + padding since the content has not loaded yet
				const { modalOuterHeight, modalOuterWidth } = getModalOuterSize(modal);

				const windowWidth = Math.floor($(window).width());
				const windowHeight = Math.floor($(window).height());
				const initialFocusOnFirstContent = isInitialFocusOnFirstContent(o.initialFocus);

				// initialize Focus Trap inside the modal
				modalFocusTrap = initModalFocusTrap(modal[0]);

				// remember options
				modal.data('options', o);

				// if class added to lpModal
				if (o.lpModalClass.length !== 0) {

					modal.addClass(o.lpModalClass);

				}

				// if modal is not fullscreen
				if (!o.fullScreen) {

					// check if width and height are larger than window
					// if width is more than window width
					if (o.width + modalOuterWidth > windowWidth) {

						// change width to fit window
						o.width = windowWidth - modalOuterWidth;

					}
					// if height is more than window height
					if (o.height + modalOuterHeight > windowHeight) {

						// change height to fit window
						o.height = windowHeight - modalOuterHeight;
						// add 25 to accomodate vertical scrollbar
						o.width += 25;

					}

				} else {

					// if modal is fullscreen

					calculateFullScreenSize(o, {
						x: modalOuterWidth,
						y: modalOuterHeight
					});

				}

				// if modal is using on page content
				if (o.src.length === 0) {

					// replace the content with a placeholder for easy return after close, if it's already on the page
					if (o.content.parents('body').length) {

						o.content.after($('<div id="lpModalContentPlaceholder" />').addClass('hidden'));

					}

					// place content in modalContent
					modalContent.append(o.content.show());

				} else {

					// if modal is embedding an iframe
					const iframe = document.createElement('iframe');
					iframe.id = 'modalIframe';
					iframe.addEventListener('load', () => {

						if (window.isIpad()) {

							$('#modalContent').css({
								overflow: 'auto',
								webkitOverflowScrolling: 'touch'
							});

						}

						// activate focus trap after iframe has completely loaded
						// and initialFocus is on the first focusable content inside the iframe
						if (initialFocusOnFirstContent) {

							modalFocusTrap.activate();

						}

						iframeOnload();

					});
					iframe.src = o.src;
					iframe.setAttribute('width', '100%');
					iframe.setAttribute('height', '100%');
					iframe.setAttribute('tabindex', '0');
					iframe.setAttribute('frameborder', '0');
					iframe.setAttribute('scrolling', 'auto');
					iframe.setAttribute('horizontalscrolling', 'no');
					iframe.setAttribute('verticalscrolling', 'no');

					modalContent.append(iframe);
					modalContent.append(iframeModalNextFocusHtml);

				}

				// set width, height, and background color values for #lpModal
				modal.css({
					width: `${o.width}px`,
					backgroundColor: o.bgColor
				});

				if (o.width === 'auto') {

					modal.css({
						height: 'auto'
					});

				} else {

					modal.css({
						height: `${o.height}px`
					});

				}

				// set height value for #lpModalContent
				modalContent.css({
					height: `${o.height}px`
				});

				// if backdrop set to false, set background to none;
				if (!o.backdrop) {

					$backdrop.css({
						background: 'url(/img/global/trans.gif) repeat'
					});

				}

				// fade in backdrop and modal popup
				$backdrop.fadeTo(500, 1);
				modal.fadeIn(500, () => {

					// activate focus trap after the modal opens
					// no need to wait for it to fully load to activate focus trap if modal content is an iframe and if
					// initialFocus is on the modal itself or the Close button and not on the first focusable content
					if (!o.src || !initialFocusOnFirstContent) {

						modalFocusTrap.activate();

					}

					o.afterOpenEvt();

				});

				// run openEvt function if there is one
				o.openEvt();

				// close modal functionality
				function closeModal (e) {

					if (o.preCloseEvt(e)) {

						// fade out backdrop and modal popup
						modal.fadeOut(300, () => {

							$backdrop.fadeOut(200, () => {

								modalFocusTrap.deactivate();

								// destroy modal markup
								if (iframeModal) {

									// set iframe src to blank before destroying the modal markup to avoid js error
									iframeModal.src = 'about:blank';

								} else {

									// replace the placeholder with the modal content
									$('#lpModalContentPlaceholder')
										.after(o.content.hide())
										.remove();

								}

								modal.remove();
								$backdrop.remove();
								o.closeEvt(e);

							});

						});

					}

				}

				// close button and backdrop click
				function handleClose(e) {
					
					if (!$(e.currentTarget).is($closeBtn) && e.target.id !== 'lpModalBackdrop') {

						return true;

					}

					if (!o.backdropClose && $(this).attr('id') === 'lpModalBackdrop') {

						return true;

					}

					closeModal(e);

					return false;

				}

				// combine two selector with one event handler for less redundancy
				$closeBtn.add($backdrop).off('click').on('click', handleClose);

				if (o.closeOnEscape) {

					// Remove previous listener first to prevent multiple event listeners)
					$(document)
						.off('keydown.lpModal')
						.on('keydown.lpModal', (e) => {

							if (e.keyCode === 27) {

								closeModal(e);

							}

						});

				}
				const closeOnEnterKey = function (e) {

					const keyCode = e.keyCode || e.which;

					if (keyCode === 13) {

						closeModal(e);

					}

				};

				$closeBtn.off('keydown', closeOnEnterKey).on('keydown', closeOnEnterKey);

			}

			// if modal should open on code run
			if (o.onInit) {

				initiateModal();

				// if not then make it run on click

			} else {

				$(this).click(() => {

					initiateModal();
					return false;

				});

			}

		});

		if (window.isIpad()) {

			$(window)
				.off('orientationchange.lpModal')
				.on('orientationchange.lpModal', () => {

					setTimeout(() => {

						$('#lpModal').lpModalResize();

					}, 0);

				});

		}

		return {
			// Expose method to change plugin options
			// NOTE: Changes to plugin options (except for showCloseBtn) that have already been applied
			// and will never be evaluated again later will not take effect
			changeOptions (options) {

				$.extend(o, options);
				if (o.showCloseBtn) {

					$(o.closeBtn).removeClass('hidden');

				} else {

					$(o.closeBtn).addClass('hidden');

				}

			},

			iframeOnload () {

				if (typeof iframeOnload === 'function') {

					iframeOnload();

				}

			}
		};

	};

	// close function available to outside world
	$.fn.lpModalClose = function (options) {

		const closeDefaults = {
			onInit: true, // should close happen when called?
			closeBtn: '#lpModalClose'
		};

		// combine defaults and passed in options
		const closeOptions = $.extend(closeDefaults, options);

		// if onInit is true run closeModal now
		if (closeOptions.onInit) {

			$(closeOptions.closeBtn).click();

			// else tie click event to element passed in

		} else {

			$(this).click((e) => {

				e.preventDefault();
				$(closeOptions.closeBtn).click();

			});

		}

	};

	// resize function available to the whole universe
	$.fn.lpModalResize = function (resizeOptions) {

		const resizeDefaults = {
			url: null,
			action: 'resize',
			noAnimation: false
		};

		// combine defaults and passed in options
		const rO = $.extend(resizeDefaults, resizeOptions);

		if (rO.action === 'childSecure') {

			window.location = `/controls/ResizeModal.aspx?width=${rO.width}&height=${rO.height}&url=${rO.url}`;

		}

		if (rO.action === 'childNonSecure') {

			window.location = `/controls/ResizeModal.aspx?width=${rO.width}&height=${rO.height}&url=${rO.url}`;

		}

		if (rO.action === 'resize') {

			// Margin should not cut off Close button
			const yMargin = 15;
			const xMargin = 15;
			const modal = window.parent.$('#lpModal');
			const modalContent = window.parent.$('#lpModalContent');
			// Find the modal's existing border and padding, along with a minimum margin to resize within
			const horizontalMarginBorderPadding = Math.floor(modal.outerWidth(false) - modal.width() + xMargin * 2);
			const verticalMarginBorderPadding = Math.floor(modal.outerHeight(false) - modal.height() + yMargin * 2);
			const windowWidth = Math.floor($(window).width());
			const windowHeight = Math.floor($(window).height());
			let modalOptions;

			// if no size specified, set default values
			if (!rO.width && !rO.height) {

				modalOptions = modal.data('options') || {};

				if (modalOptions.fullScreen) {

					rO.fullScreenOffset = modalOptions.fullScreenOffset;

					const { modalOuterHeight, modalOuterWidth } = getModalOuterSize(modal);

					// set to fullscreen size which may have fixed offset
					calculateFullScreenSize(rO, {
						x: modalOuterWidth,
						y: modalOuterHeight
					});

				} else {

					// set size the same as current size
					rO.width = modal.width();
					rO.height = modal.height();

				}

			}

			// check if width and height are larger than window
			// if width is more than window width
			if (rO.width + horizontalMarginBorderPadding > windowWidth) {

				// change width to fit window
				rO.width = windowWidth - horizontalMarginBorderPadding;

			}
			// if height is more than window height
			if (rO.height + verticalMarginBorderPadding > windowHeight) {

				// change height to fit window
				rO.height = windowHeight - verticalMarginBorderPadding;

			}

			if (rO.noAnimation) {

				modalContent.css({
					width: rO.width,
					height: rO.height
				});

				modal.css({
					width: rO.width,
					height: rO.height
				});

				modalContent.removeClass('noScroll');

			} else {

				modalContent.animate(
					{
						width: rO.width,
						height: rO.height
					},
					200
				);

				modal.animate(
					{
						width: rO.width,
						height: rO.height
					},
					200
				);

			}

			setTimeout(() => {

				if (rO.url) {

					if (rO.url.indexOf('?') >= 0) {

						window.location = `${rO.url}&resized=true`;

					} else {

						window.location = `${rO.url}?resized=true`;

					}

				}

			}, 400);

		}

	};

	// only call this if 'fullScreen' option is set to true
	function calculateFullScreenSize (options, modalOuterSize) {

		const windowWidth = Math.floor($(window).width());
		const windowHeight = Math.floor($(window).height());

		if (options.fullScreenOffset) {

			let offsetWidth = 0;
			let offsetHeight = 0;
			let divisorX = 1;
			let divisorY = 1;

			// adjust the offset for iPad
			if (window.isIpad()) {

				if (windowWidth < 1024) {

					divisorX = 2;

				} else {

					divisorX = 1.5;
					divisorY = 0.85;

				}

			}

			if (options.fullScreenOffset.x > 0) {

				offsetWidth = 2 * (options.fullScreenOffset.x / divisorX);

			}

			if (options.fullScreenOffset.y > 0) {

				offsetHeight = 2 * (options.fullScreenOffset.y / divisorY);

			}

			const width = windowWidth - modalOuterSize.x - offsetWidth;
			let height = windowHeight - modalOuterSize.y - offsetHeight;

			// in portrait mode, don't make the modal height > width
			if (height > width) {

				height = width / 1.55;

			}

			options.width = width;
			options.height = height;

		} else {

			options.width = windowWidth;
			options.height = windowHeight;

		}

	}

}(jQuery));